import httpService from '@/modules/common/services/httpService';

const baseRoute = '/business/accounts/v1';

const fetchBranding = async () => httpService.get(`${baseRoute}/branding`)
  .then((res) => res.data?.data.branding);

const fetchAttributes = async () => httpService.get(`${baseRoute}/attributes`)
  .then((res) => res.data?.data.attributes);

const fetchFeaturesFlags = async (businessUid) => httpService.get(`platform/v1/businesses/${businessUid}/features`)
  .then((res) => res.data?.data);

const fetchBusiness = async (businessUid) => httpService.get(`platform/v1/businesses/${businessUid}`)
  .then((res) => res.data?.data);

const fetchBusinessProfile = async () => httpService.get('v2/profile/business')
  .then((res) => res.data);

const fetchBusinessSettings = async (businessUid) => httpService.get(`v2/settings/businesses/${businessUid}`)
  .then((res) => res.data);

const updateBusinessSettings = async (businessUid, payload) => httpService.put(`v2/settings/businesses/${businessUid}`, payload)
  .then((res) => res.data);

const fetchSmsBalance = async (businessUid) => httpService.get(`platform/v1/businesses/${businessUid}/sms_balance`)
  .then((res) => res.data);

const fetchSmsQuotas = async (businessUid) => httpService.get(`platform/v1/businesses/${businessUid}/sms_quotas`)
  .then((res) => res.data);

const updateSmsAutoReload = async (businessUid, enabled) => httpService.put(`platform/v1/businesses/${businessUid}/sms_auto_reload`, { auto_reload: enabled })
  .then((res) => res.data);

export default {
  fetchBranding,
  fetchAttributes,
  fetchFeaturesFlags,
  fetchBusiness,
  fetchBusinessProfile,
  fetchBusinessSettings,
  updateBusinessSettings,
  fetchSmsBalance,
  fetchSmsQuotas,
  updateSmsAutoReload,
};
